<template>
<div>
  <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
          <h2>{{$t('common.emailAuthentication')}}</h2>
      </div>
  </div>
  <section class="sub_contents_wrap container text-center">
      <h3>{{$t('common.emailAuthenticationIsComplete')}}</h3>
      <h3 style="margin-bottom: 30px;"></h3>
      <router-link to="/main" @click.native="$store.commit('setActive','')" class="btn btn-primary">{{$t('common.main')}}</router-link>
  </section>
</div>
</template>

<script>
import { setValidateYn } from '@/api/user';

export default {
data() {
        return { 
            faq: {},
        
        }  
    },
    methods : {
        async fetchData(){  
            try{
                const {data} = await setValidateYn(this.$route.params.param);
                if(!data.status){
                    alert(this.$t("alert.ErrorPlzcontactManager"));
                }else{
                    console.log('ddd');
                    this.$emit('getValidateMailStatus', {emailValidId : this.$route.params.param});
                }
            } catch(err){
                console.log(err);
            }
        },
      
    },
    mounted (){
        // console.log();
        this.fetchData();
    }
}
</script>

<style>

</style>

